module.exports = __webpack_public_path__ + "assets/arrow-left.a10578a6.svg";